import { Card, ICardStyles } from '@coherence-design-system/controls';
import { camelCase } from 'lodash';
import { FontSizes, ITheme } from '@fluentui/react';
import { useThemeData } from '@msrceng/theme';
import { ReactNode } from 'react';

const cardStyles = (theme: ITheme): Partial<ICardStyles> => ({
  root: {
    backgroundColor: theme?.semanticColors?.bodyBackground,
    minWidth: '5em',
    maxWidth: 'unset',
    'h1,h2': {
      fontSize: FontSizes.xLarge,
    },
    'h3,h4': {
      fontSize: FontSizes.mediumPlus,
    },
  },
  layout: {
    '@media print': {
      padding: '0px',
    },
  },
});

/** A standard card with a header and children, prestyled and preconfigured to be a full-page layout
 */
export const PageCard = ({ header, children, id }: IPageCardProps) => {
  const { theme } = useThemeData();
  const htmlId = camelCase(id || header + '');

  return (
    <div
      style={{
        padding: '12px 3%',
        display: 'flex',
        flexGrow: 1,
        flexShrink: 1,
        justifyContent: 'center',
      }}
      id={htmlId}
      className='print-page'
    >
      <Card
        header={
          header && (
            <header
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0.25rem 1rem 0 1rem',
              }}
            >
              {header}
            </header>
          )
        }
        data-testid={htmlId}
        styles={cardStyles(theme)}
      >
        {children}
      </Card>
    </div>
  );
};

interface IPageCardProps {
  children: ReactNode;
  header: ReactNode;
  id?: string;
}
